module.exports = __webpack_public_path__ + "static/media/img17.87457bd1.jpg";